import { timer } from "rxjs";
// Wird benutzt für einfache Renderverzögerungen, ExpressionChangedAfterItHasBeenChecked Fehler leichte Verzögerungen um  Komponentenausführungen wie Validierungen ausführen zu können 
export const delayHelper = (method: any) => {
	const delaySubscription = timer(0).subscribe(() => {
		method()
		delaySubscription.unsubscribe()
	})
}